export type AnalyticsConnectionState = {
  status?: string | null;
  analytics_sync_status?: string | null;
};

export const isNonActiveAnalyticsConnection = ({ status }: AnalyticsConnectionState) => (
  status !== null && status !== undefined && status !== 'active'
);

export const effectiveAnalyticsSyncStatus = (connection: AnalyticsConnectionState) => (
  isNonActiveAnalyticsConnection(connection)
    ? 'reconnect_required'
    : connection.analytics_sync_status
);

export const isActiveAnalyticsSync = (connection: AnalyticsConnectionState) => (
  connection.status === 'active'
  && (connection.analytics_sync_status === 'queued' || connection.analytics_sync_status === 'running')
);
